import { authenticatedApi } from '../../../../../../Api/api';
import { IDocument } from '../../../../../../models/document';
import env from '../../../../../../config/env';

export default function DocumentsTableList({
  data,
  actions
}: {
  data: IDocument[];
  actions?: Array<{
    label: string;
    onClick: (document: IDocument) => void;
  } | (
    (document: IDocument) => ({ label: string; onClick: (document: IDocument) => void })
  )>;
}) {

  const downloadFile = async (document: IDocument) => {
    const downloadTokenResponse = await authenticatedApi.get("/documents/" + document.id + "/get-download-token");
    const downloadToken = downloadTokenResponse.data?.documentToken;

    if (!downloadToken) return;
    window.open(env.PUBLIC_API_URL + "/documents/" + document.id + "/download?downloadType=view&documentDownloadToken=" + downloadToken, '_blank');
  }

  return (
    <table className="table table-hover">
      <tbody>
        {data.sort((docA, docB) => {
          const dateA = new Date(docA.dateCreation || docA.savDocumentsRelationship?.dateCreation || "");
          const dateB = new Date(docB.dateCreation || docB.savDocumentsRelationship?.dateCreation || "");
          return dateB.getTime() - dateA.getTime();
        }).map((document) => (
          <tr key={document.id}>
            <td>
              {document.label}
              {document.isFromContract ? (
                <span className="badge bg-secondary ms-2">Contrat</span>
              ) : (
                <span className="badge bg-primary ms-2">SAV</span>
              )}
            </td>
            <td>
              {document.isFromContract 
                ? "Document de contrat"
                : (document.savDocumentsRelationship?.user?.firstName || "") + " " + (document.savDocumentsRelationship?.user?.lastName || "")
              }
            </td>
            <td>{(() => {
              const dateStr = document.savDocumentsRelationship?.dateCreation || document.dateCreation;
              if (!dateStr) return "";
              const date = new Date(dateStr);
              return date.toLocaleDateString() + " " + date.toLocaleTimeString();
            })()}</td>
            <td className="fw-bold d-flex flex-row justify-content-end">
              {/* Bouton de téléchargement - toujours disponible */}
              <a onClick={() => downloadFile(document)} data-bs-toggle="tooltip" data-bs-html="true" type="button" className="btn btn-primary text-decoration-none">
                  <i className="fa-solid fa-download"></i>
              </a>
              
              {/* Actions supplémentaires - seulement pour les documents non-contrat */}
              {!document.isFromContract && actions?.map((action, index) => {
                const onClick = typeof action === 'function' ? action(document).onClick : action.onClick;
                const label = typeof action === 'function' ? action(document).label : action.label;
                return (
                  <a key={index} onClick={() => onClick(document)} data-bs-toggle="tooltip" data-bs-html="true" type="button" className="btn btn-primary text-decoration-none ms-2">
                    {label}
                  </a>
                )
              })}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}